import { ContentLink, EpiContent, EpiLink } from '@api/types';
import { createContext, useCallback, useContext, useState } from 'react';

type DropdownMenuProviderProps = {
  children: React.ReactNode;
  buttonLabel: string;
  content?: EpiContent;
  contentLink?: ContentLink;
  primaryLinks?: EpiLink[];
};

type DropdownMenuContextType = {
  isOpen: boolean;
  handleOpenToggle: () => void;
  anchorEl: HTMLElement | null;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  buttonLabel: string;
  content?: EpiContent;
  contentLink?: ContentLink;
  primaryLinks?: EpiLink[];
};
export const DropdownMenuContext = createContext<DropdownMenuContextType | null>(null);

export const DropdownMenuProvider = ({
  children,
  buttonLabel,
  content,
  contentLink,
  primaryLinks,
}: DropdownMenuProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    handleOpenToggle();
  };

  const handleOpenToggle = useCallback(() => {
    setIsOpen((previousOpen) => !previousOpen);
  }, []);

  const contextValue = {
    isOpen,
    anchorEl,
    handleClick,
    handleOpenToggle,
    buttonLabel,
    content,
    contentLink,
    primaryLinks,
  };
  return (
    <DropdownMenuContext.Provider value={contextValue}>{children}</DropdownMenuContext.Provider>
  );
};

export const useDropdownMenuContext = () => {
  const context = useContext(DropdownMenuContext);
  if (!context) {
    throw new Error('useDropdownMenuContext must be used within a DropdownMenuProvider');
  }
  return context;
};
